import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; 
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./Assets/css/product_list.css";
import "../src/Assets/css/style.css";
import "../src/Assets/css/style2.css";
import "../src/Assets/css/mega_menu.css";
import "../src/Assets/css/responsive.css";
import "../src/Assets/css/single_product.css";
import "../src/Assets/css/stripe.css";
import "./Assets/css/product_search.css";
import "./Assets/css/location.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from "react-redux";
import { store } from "./Store/store";
import screenImg from "./Assets/images/wdscreen.png";
import { Helmet } from "react-helmet";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// const RootComponent = () => {
//   const [showSplash, setShowSplash] = useState(true);

//   useEffect(() => {
//     if (window.location.pathname == "/"){
//        setTimeout(() => {
//       setShowSplash(false);
//     }, 3000);
//     }else{
//       setShowSplash(false)
//     }
  
//   }, []);

//   return showSplash ? (
//     <>
//     <Helmet>
//     <meta charset="UTF-8"/>
//     <title>Wedding Day Diamonds</title>
//   <meta
//     name="description"
//     content="Engagment ring"
//   ></meta>
//   <meta name="keywords" content="Rings, Bands"></meta>
//     </Helmet>
//     <div
//       style={{
//         height: "100vh",
//         width: "100%",
//       }}
//       className="fixed inset-0 d-flex align-items-center justify-content-center "
//       onClick={() => setShowSplash(false)}
//     >
//       <img
//         src={require("./Assets/images/logo.webp")}
//         className="img-fluid"
//         alt="logo"
//       />
//     </div>
//     </>
//   ) : (
//     <App />
//   );

//   // );
// };

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <RootComponent />
//   </Provider>
// );

// reportWebVitals();
